import React from "react";
import { useLanguage } from "../context/LanguageContext";

const Contact = () => {
  const { lang } = useLanguage();

  const t = {
    sq: {
      title: "Ku gjendemi ne?",
      address: "📍 MasterPhone - Rruga e Kavajës 133, Tiranë",
    },

    en: {
      title: "Where are we located?",
      address: "📍 MasterPhone - 133 Kavaja Street, Tirana, Albania",
    },
  };

  const text = t[lang] || t.sq;

  return (
    <div className="p-6 space-y-4">
      
      <h2 className="text-xl font-semibold">
        {text.title}
      </h2>

      <div>
        {text.address}
      </div>

      <div className="w-full rounded-xl overflow-hidden shadow-md mt-4">
        <iframe
          title="MasterPhone Location"
          src="https://www.google.com/maps?q=Master+Phone+Kavaja+St+133+Tirana+Albania&output=embed"
          width="100%"
          height="300"
          style={{ border: 0 }}
          loading="lazy"
          allowFullScreen
        ></iframe>
      </div>

    </div>
  );
};

export default Contact;